import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { isNull, isUndefined } from 'lodash';
import Cookies from 'universal-cookie';
import { ROUTES } from '../../constants';
import { useHistory } from 'react-router-dom'

export default function PrivateRoute({ auth, ...rest }) {
  const { user } = useSelector(state => state.userAuthentication);
  let loggedIn = useSelector(state => state.userAuthentication.loggedIn);
  const cookies = new Cookies();
  const history = useHistory();
  useEffect(() => {
    const user = cookies.get('user');
    if(isNull(user) || isUndefined(user)) {
      loggedIn = false;
      history.push(ROUTES.LOGIN);
    }
  }, []);
  return (
    loggedIn ? <Route {...rest} /> : <Redirect to="/" />
  )
}